module.exports = __webpack_public_path__ + "static/media/map-spinner.576226a7.gif";